import React from 'react'
import ReactDOM from 'react-dom/client'

import '@/assets/scss/styles.scss'

import App from './App'
import reportWebVitals from './reportWebVitals'

// Suppress benign ResizeObserver loop notification from CKEditor in dev overlay
const _onerror = window.onerror
window.onerror = (message, source, lineno, colno, error) => {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return true
  }
  return _onerror?.(message, source, lineno, colno, error) ?? false
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
  {
    identifierPrefix: 'idx',
  }
)
root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
